export const STRIPE_IGNORED_ERROR_CODES_LIST = [
  'payment_intent_authentication_failure',
  'card_declined',
  'incorrect_cvc',
  'invalid_cvc',
  'expired_card',
  'incorrect_number',
  'processing_error',
]
